import { getTableColumns } from "drizzle-orm";
import { index, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import z from "zod";

import { consentDocumentsTable } from "./consentDocumentsSchema";
import { patientsTable } from "./patientsSchema";
import { customTimestamp } from "./utils/types";

export const consentDocumentSignaturesTable = pgTable(
  "consent_document_signatures",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    consentDocumentId: uuid("consent_document_id")
      .references(() => consentDocumentsTable.id, { onDelete: "cascade" })
      .notNull(),
    patientId: uuid("patient_id")
      .notNull()
      .references(() => patientsTable.id, { onDelete: "cascade" }),
    signatureDataUri: text("signature_data_uri").notNull(),
    adminDownloadUrl: text("admin_download_url").unique(
      "consent_document_signatures_admin_download_url_unique_index",
      {
        nulls: "distinct",
      },
    ),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [
    index("consent_document_signatures_consent_document_id_index").on(
      table.consentDocumentId,
    ),
    index("consent_document_signatures_patient_id_index").on(table.patientId),
  ],
);

export const consentDocumentSignaturesColumns = getTableColumns(
  consentDocumentSignaturesTable,
);

export const consentDocumentSignaturesSchema = createSelectSchema(
  consentDocumentSignaturesTable,
);

export const consentDocumentSignaturesInsertSchema = createInsertSchema(
  consentDocumentSignaturesTable,
  {},
).omit({
  adminDownloadUrl: true,
  createdAt: true,
  updatedAt: true,
});

export type ConsentDocumentSignaturesInsertType = z.infer<
  typeof consentDocumentSignaturesInsertSchema
>;

export type ConsentDocumentSignaturesType = z.infer<
  typeof consentDocumentSignaturesSchema
>;
